class ProductMediaGallery extends ModalDialog {
  constructor() {
    super();
  }

  show(opener) {
    super.show(opener);
    this.showMedia(this.openedBy.dataset.mediaId);
    this.processMediaItems();
    this.productGallerySlider();
  }

  processMediaItems() {
    const mediaItems = document.querySelectorAll('.main-product__media-item:not(.main-product__media-item-hidden)');
    const mainImages = document.querySelectorAll('.main-product__gallery-main-img');

    mediaItems.forEach(mediaItem => {
        const thumbnailAlt = mediaItem.querySelector('img').getAttribute('thumbnail-alt');

        mainImages.forEach(mainImage => {
            const mainImageAlt = mainImage.querySelector('img').getAttribute('thumbnail-alt');
            if (thumbnailAlt === mainImageAlt) {
                mainImage.parentElement.classList.remove('pdp-element-hidden');
            } else {
                mainImage.parentElement.classList.add('pdp-element-hidden');
            }
        });
    });
  }

  productGallerySlider() {
    var modalMainGallery = document.querySelector('.main-product__gallery-modal-slider');

    if (modalMainGallery) {

      // var screenWidth = window.screen.width;

      // if(screenWidth >= 990) {
      //   var thumbDirection = 'vertical'
      // } else {
      //   var thumbDirection = 'horizontal'
      // }

      // var mainSliderItems = document.querySelectorAll('.main-product__gallery-modal-slider .swiper-slide');

      // var initialThumbSlide = 0;
      // var dataIndexArray = [];
      // mainSliderItems.forEach(function (slide) {
      //   if (!slide.classList.contains('pdp-element-hidden')) {
      //     var dataIndex = slide.getAttribute('data-slide-index');
      //     if (dataIndex !== null) {
      //       dataIndexArray.push(parseInt(dataIndex));
      //       return;
      //     }
      //   }
      // });

      // if (dataIndexArray.length > 0) {
      //   initialThumbSlide = dataIndexArray[0];
      // }

      var mainSwiper = new Swiper('.main-product__gallery-modal-slider', {
        slidesPerView: 1,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: ".pdp-gallery-next button",
          prevEl: ".pdp-gallery-prev button"
        }
      });

    }

  }

  showMedia(id) {
    const galleryMedia = this.querySelector(`[data-media-id="${id}"]`);

    if (!galleryMedia) {
      return;
    }

    if (window.innerWidth < 990) {
      const mediaTrigger = galleryMedia.querySelector('button');

      this.querySelectorAll('[data-media-id]').forEach((media) => {
        media.style.display = 'none';
      })
      galleryMedia.style.display = 'block';

      if (mediaTrigger) {
        mediaTrigger.click();
        const iframe = galleryMedia.querySelector('iframe');

        if (iframe) {
          if (iframe.classList.contains('js-youtube')) {
            iframe.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*')
          } else if (iframe.classList.contains('js-vimeo')) {
            iframe.contentWindow.postMessage('{"method":"play"}', '*');
          }
        }
      }

      return;
    }

    this.querySelectorAll('[data-media-id]').forEach((media) => {
      media.style.display = 'block';
    })
    galleryMedia.scrollIntoView();
  }
}

customElements.define('product-media-gallery', ProductMediaGallery);
